import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';
import Button, { BUTTON_WIDTH } from '@gc-npm/components.button';
import sendGaEvent from '@gc-npm/utils.metrics.send-ga-component-event';
import Carousel from '@gc-npm/components.carousel';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
} from '@gc-npm/components.text';
import CustomLink from '@gc-npm/components.custom-link';
import Glyph from '@gc-npm/components.icon-glyph';

import { actions as modulesActions } from '@/reducers/modules';
import MobileLineCard from '@/components/Card/MobileLineCard';
import { SCREEN_TYPES } from '@/utils/constants';
import UpgradePrices from "@/components/UpgradePrices"

const MobilesLinesModal = ({ screenType, linesToSelect, customOnclickRecom }) => {
  const dispatch = useDispatch();

  const taggingInfo = {
    componentName: 'MobilesLinesModal',
    componentProduct: '',
    componentContent: '',
    componentVariation: '',
  };

  useEffect(() => {
    sendGaEvent({
      ...taggingInfo,
      eventType: 'print-success',
    })
  }, []);
  const lme = useSelector((state) => state.modulos?.conectividad.lme);
  const modulos = useSelector((state) => state.modulos);

  const lmeModules = lme?.items || [];

  const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: '',
      }),
    );
  };
  const initialLines = {};
  lmeModules.forEach((eachLine) => {
    initialLines[eachLine?.id] = Math.max(
      Number(eachLine.quantity) || 0,
      Number(eachLine.minQuantity) || 0,
    );
  });
  if (linesToSelect && Array.isArray(linesToSelect) && linesToSelect.length > 0) {
    linesToSelect.forEach((eachLine) => {
      const module = lmeModules.find(({ id }) => id === eachLine.id);
      initialLines[eachLine.id] = Math.max(
        Number(eachLine.qty) || 0,
        Number(module?.minQuantity) || 0,
      );
    })
  }
  const [linesToPurchase, setLinesToPurchase] = useState(initialLines);

  const selectLines = () => {
    const ids = Object.entries(linesToPurchase).map(([key, value]) => ({
      id: key,
      qty: value,
    }));
    if (customOnclickRecom) {
      customOnclickRecom(ids)
    } else {
      dispatch(
        modulesActions.selectModules({
          ids,
          category: 'conectividad',
          subcategory: 'lme',
        }),
      );
    }
    onCloseModal();
  };
  return (
    <div className="MobilesLinesModal">
      <div className="iconCerrar">
        <CustomLink
          ariaLabel="Cerrar"
          taggingInfo={{ ...taggingInfo, componentContent: 'Cerrar' }}
          onClick={onCloseModal}
        >
          <Glyph id="cerrar" height={20} width={20} color={TEXT_COLOR.MOVISTAR_BLUE} />
        </CustomLink>
      </div>

      <div className="title">
        <TextInfo
          text="Líneas Móviles Adicionales"
          kind={TEXT_KIND.PARAGRAPH}
          color={TEXT_COLOR.BLACK}
          size={TEXT_SIZE.T4}
          align={TEXT_ALIGN.LEFT}
          fontType={TEXT_FONT_WEIGHT.BOLD}
        />
      </div>
      {/* {modulos?.legalTexts &&(
        <UpgradePrices/>
      )} */}
      <div className="Cards">
        <Carousel slideSeparation={8} maxPointNum={3} breakpoint={768}>
          {lmeModules.map((element) => (
            <MobileLineCard
              linesToPurchase={linesToPurchase}
              onClick={setLinesToPurchase}
              module={element}
              key={element?.title?.text}
              taggingInfo={taggingInfo}
            />
          ))}
        </Carousel>
      </div>

      <div className="guardar">
        <Button
          label="Guardar y salir"
          onClick={selectLines}
          taggingInfo={{
            ...taggingInfo,
            componentContent: 'Guardar y salir',
            componentProduct: linesToPurchase,
          }}
          width={screenType === SCREEN_TYPES.MOBILE ? BUTTON_WIDTH.FULL : BUTTON_WIDTH.MEDIUM}
          forceExternal
        />
      </div>

      <style jsx>
        {`
          .MobilesLinesModal {
            
            height: auto;
            z-index: 45;
            background-color: white;
            padding: 1rem 2rem;
            border-radius: 20px;
            max-height: 90vh;
            overflow-y: auto;
            overflow-x: hidden;
            .iconCerrar {
              display: flex;
              flex-direction: row;
              justify-content: flex-end;
            }
            .guardar{
            padding-top:1rem;                  
            }
            
          }
          @media screen and (max-width: 768px) {
            .MobilesLinesModal {
              padding: 1rem;
              border-radius: 20px 20px 0 0;
              min-width: 100vw;
              min-height: auto;
              display: flex;
              flex-direction: column;
              gap: 1rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default MobilesLinesModal;
